
    <footer class="border-t border-[color:var(--border)] bg-[color:var(--card)] text-[color:var(--foreground)]" aria-labelledby="footer-heading">
      <h2 id="footer-heading" class="sr-only">Footer</h2>
      <div class="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8 lg:py-16">
        <div class="xl:grid xl:grid-cols-3 xl:gap-8">
          <!-- Brand section -->
	          <div class="space-y-8 xl:col-span-1">
	            <a routerLink="/" class="flex items-center gap-3">
	              <div class="h-12 px-3 flex items-center justify-center">
	                <img [src]="logoSrc" alt="nibni" class="h-9 w-auto object-contain select-none" />
	              </div>
	            </a>
            <p class="text-sm leading-6 text-[color:var(--muted-foreground)]">
              Your trusted partner in real estate. Connecting developers, investors, and homeowners globally.
            </p>
            <div class="flex space-x-6">
              <a
                *ngFor="let item of socialLinks"
                [href]="item.href"
                class="text-[color:var(--text-subtle)] hover:text-[color:var(--primary)] transition-colors"
              >
                <span class="sr-only">{{ item.name }}</span>
                <lucide-icon [name]="item.icon" class="h-6 w-6"></lucide-icon>
              </a>
            </div>
          </div>

          <!-- Links sections -->
          <div class="mt-16 grid grid-cols-2 gap-8 xl:col-span-2 xl:mt-0 md:grid-cols-3">
            <div>
              <h3 class="text-sm font-semibold leading-6 text-[color:var(--foreground)]">Properties</h3>
              <ul role="list" class="mt-6 space-y-4">
                <li *ngFor="let item of footerNavigation.properties">
                  <a
                    [routerLink]="item.href"
                    class="text-sm leading-6 text-[color:var(--muted-foreground)] hover:text-[color:var(--primary)] transition-colors"
                  >
                    {{ item.name }}
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <h3 class="text-sm font-semibold leading-6 text-[color:var(--foreground)]">Resources</h3>
              <ul role="list" class="mt-6 space-y-4">
                <li *ngFor="let item of footerNavigation.resources">
                  <a
                    [href]="item.href"
                    class="text-sm leading-6 text-[color:var(--muted-foreground)] hover:text-[color:var(--primary)] transition-colors"
                  >
                    {{ item.name }}
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <h3 class="text-sm font-semibold leading-6 text-[color:var(--foreground)]">Terms & Privacy</h3>
              <ul role="list" class="mt-6 space-y-4">
                <li *ngFor="let item of footerNavigation.legal">
                  <a
                    [routerLink]="item.href"
                    class="text-sm leading-6 text-[color:var(--muted-foreground)] hover:text-[color:var(--primary)] transition-colors"
                  >
                    {{ item.name }}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <!-- Bottom section -->
        <div class="mt-16 border-t border-[color:var(--border)] pt-8 sm:mt-20 lg:mt-24">
          <p class="text-xs leading-5 text-center text-[color:var(--text-subtle)]">
            &copy; {{ currentYear }} nibni Real Estate Platform. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
    
